import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUser } from '../../utils/auth';
import { isSuperAdmin } from '../../utils/role';

/** 仅超级管理员可访问 */
class RequireSuperAdmin extends React.Component {
    render() {
        const { children } = this.props;
        if (!isAuthenticated()) {
            return <Navigate to="/login" replace />;
        }
        if (!isSuperAdmin(getUser())) {
            return <Navigate to="/admin/users" replace />;
        }
        return children;
    }
}

export default RequireSuperAdmin;
